module.exports = __webpack_public_path__ + "img/19-4.b0d11e59.png";